import { Button } from "PFComponents/button";
import DownArrowIcon from "PFIcons/down_arrow.svg";
import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";

import css from "./onboarding_header.module.scss";

const OnboardingHeader = ({ title, next, back, done, t }) => (
  <header className={css.root} data-qa-id="OnboardingHeader">
    {back && (
      <Button kind="blank" rootClassName={css.back} onClick={back} data-qa-id="OnboardingHeader.back">
        <DownArrowIcon className={css.backIcon} width={20} height={20} />
        {` ${t("back")}`}
      </Button>
    )}
    <h1>{title}</h1>
    {next && (
      <Button onClick={next} qaId="OnboardingHeader.next">
        {t("next")}
      </Button>
    )}
    {done && (
      <Button onClick={done} qaId="OnboardingHeader.done">
        {t("done")}
      </Button>
    )}
  </header>
);

OnboardingHeader.propTypes = {
  title: PropTypes.string.isRequired,
  back: PropTypes.func,
  next: PropTypes.func,
  done: PropTypes.func,
  t: PropTypes.func
};

export default withTranslation("onboarding")(OnboardingHeader);
